<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ action }}</div>
    <div slot="body">
      <a-alert type="info" class="mb-2" :message="$t('ai.mcp.set_default_extra')" />
      <dialog-selected-tips :name="$t('ai.mcp.builtin_agent')" :count="params.data.length" :action="action" />
      <dialog-table :data="params.data" :columns="params.columns" />
      <a-form v-bind="formItemLayout">
        <a-form-item :label="$t('ai.mcp.set_default')">
          <a-switch v-model="isDefault" :checkedChildren="$t('common.true')" :unCheckedChildren="$t('common.false')" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'SetDefaultAgentDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      action: this.$t('ai.mcp.set_default'),
      isDefault: this.params.data[0].default_agent,
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
    }
  },
  computed: {
    selectedItems () {
      return this.params.data
    },
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        await this.params.onManager('update', {
          id: this.params.data[0].id,
          managerArgs: {
            data: {
              default_agent: this.isDefault,
            },
          },
        })
        this.$bus.$emit('default-mcp-agent-updated')
        this.params.success()
        this.cancelDialog()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
